<style lang="less">
  @import "./css/common.less";
</style>
<template>
  <div class="custom common-content">
    <navMenu></navMenu>
    <div class="content">
      <div class="banner-items">
        <img src="../assets/images/banner_CustomMade.jpg">
        <div class="banner-title font-large">
          <span>CUSTOM MADE</span>
        </div>
      </div>
      <div class="text-content">
        <div class="pc-items">
          <ContactBox></ContactBox>
        </div>
        <div class="article">
          <div class="bread-crumbs">
            <span class="pointer" @click="goToIndex">HOME></span>
            <span>CUSTOM MADE</span>
          </div>
          <span class="article-title">CUSTOM MADE</span>
          <div class="article-content">
            <p>
              Our proven ability to assess and create designs, turn them into reality and then to produce the same quality garment repeatedly, delivering it to you.
            </p>
            <p>
              We can match your logo, embroidery, pattern etc, and our services are tailored to suit individual requirements.
            </p>
          </div>
        </div>
        <div class="mb-items">
          <ContactBox></ContactBox>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import ContactBox from '../components/contactBox'
export default {
  data () {
    return {
    }
  },
  components: {
    NavMenu,
    Footer,
    ContactBox
  },
  methods: {
    goToIndex(){
      this.$router.push('/index')
    }
  },
  watch: {},
  mounted () {
    
  }
}
</script>
<style lang="less">
  .custom{
    
  }
</style>
